import {
  ACT_DYNASTIES_FETCH_INIT,
  ACT_DYNASTIES_FETCH_200,
} from '../constants/actions';

export const dynastiesFetchInitAction = () => ({
  type: ACT_DYNASTIES_FETCH_INIT,
});

export const dynastiesFetchSuccessAction = data => ({
  type: ACT_DYNASTIES_FETCH_200,
  payload: data,
});
